import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startDate", "endDate", "customFields", "form"]
  static values = {
    preset: { type: String, default: "month" }
  }

  connect() {
    this.updateCustomFieldsVisibility()
  }

  selectPreset(event) {
    const preset = event.currentTarget.dataset.preset

    // Update active button styles - support both custom and DaisyUI classes
    this.element.querySelectorAll('[data-preset]').forEach(btn => {
      if (btn.dataset.preset === preset) {
        // Custom classes (statistics dashboard)
        btn.classList.remove('bg-gray-100', 'text-gray-700', 'hover:bg-gray-200')
        btn.classList.add('bg-[#3182F6]', 'text-white')
        // DaisyUI classes (stock_outs pending)
        btn.classList.remove('btn-ghost')
        btn.classList.add('btn-primary')
      } else {
        // Custom classes (statistics dashboard)
        btn.classList.remove('bg-[#3182F6]', 'text-white')
        btn.classList.add('bg-gray-100', 'text-gray-700', 'hover:bg-gray-200')
        // DaisyUI classes (stock_outs pending)
        btn.classList.remove('btn-primary')
        btn.classList.add('btn-ghost')
      }
    })

    this.presetValue = preset
    this.updateCustomFieldsVisibility()

    if (preset !== 'custom') {
      this.submitForm(preset)
    }
  }

  updateCustomFieldsVisibility() {
    if (this.hasCustomFieldsTarget) {
      if (this.presetValue === 'custom') {
        this.customFieldsTarget.classList.remove('hidden')
      } else {
        this.customFieldsTarget.classList.add('hidden')
      }
    }
  }

  submitForm(preset) {
    const url = new URL(window.location.href)
    url.searchParams.set('preset', preset)

    // Preserve mode parameter (for stock_outs pending page)
    if (!url.searchParams.has('mode')) {
      url.searchParams.set('mode', 'range')
    }

    if (preset === 'custom' && this.hasStartDateTarget && this.hasEndDateTarget) {
      url.searchParams.set('start_date', this.startDateTarget.value)
      url.searchParams.set('end_date', this.endDateTarget.value)
    } else {
      url.searchParams.delete('start_date')
      url.searchParams.delete('end_date')
    }

    window.location.href = url.toString()
  }

  applyCustomRange(event) {
    event.preventDefault()
    this.submitForm('custom')
  }
}
